import { supabase } from '../../../lib/supabaseClient';
import { ApiResponse } from '../../../types/api';
import { OfferLetterSchemaResponse } from '../types';
import { handleEdgeFunctionError } from '../../../utils/edgeFunctionUtils';

export async function getOfferSchemaWithEdgeFunction(
  organizationId: string,
  outletId?: string,
  jobId?: string
): Promise<ApiResponse<OfferLetterSchemaResponse>> {
  try {
    const body: Record<string, string> = { organization_id: organizationId };
    if (outletId) body.outlet_id = outletId;
    if (jobId) body.job_id = jobId;

    const { data, error } = await supabase.functions.invoke('get-offer-letter-schema', {
      body,
    });

    if (error) {
      console.error('[Edge Function Error] getOfferSchema:', error);
      const extractedError = await handleEdgeFunctionError(error);
      return { data: null, error: extractedError };
    }

    return { data: data?.data || null, error: data?.error || null };
  } catch (err) {
    console.error('[Edge Function Exception] getOfferSchema:', err);
    return { data: null, error: err };
  }
}
